import React from "react";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import { designColors } from "services/constants/designTokens";
import { StatCards } from "./StatCards";

// Counts and percentages are both derived from `users` at render time -
// never pass a precomputed percentage in. Active% + Inactive% must always
// reconcile to All=100%.
const buildStats = (users) => {
  const total = users?.length || 0;
  const active = users?.filter((u) => u?.status === "Active").length || 0;
  const inactive = total - active;
  const pct = (count) =>
    total === 0 ? "0.0" : ((count / total) * 100).toFixed(1);

  return [
    {
      key: "all",
      label: "All Users",
      count: total,
      percentLabel: `${pct(total)}% of all users`,
      icon: PeopleAltIcon,
      bg: "#EEF4FF",
      fg: "#1D4ED8",
    },
    {
      key: "active",
      label: "Active Users",
      count: active,
      percentLabel: `${pct(active)}% of all users`,
      icon: PersonAddAlt1Icon,
      bg: designColors.tealTint,
      fg: "#16A34A",
    },
    {
      key: "inactive",
      label: "Inactive Users",
      count: inactive,
      percentLabel: `${pct(inactive)}% of all users`,
      icon: PersonOffIcon,
      bg: "#F1F5F9",
      fg: "#64748B",
    },
  ];
};

export const UserStatCards = ({ users, onCardClick, activeFilter }) => {
  const stats = buildStats(users);

  return (
    <StatCards
      stats={stats}
      activeFilter={activeFilter}
      onCardClick={onCardClick}
    />
  );
};
